interface Props {
  children: string | string[]
  id?: string
}

const ScreenReaderOnly = ({ children, id }: Props) => (
  <span className="sr-only" {...(id ? { id } : {})}>
    {children}
  </span>
)

export default ScreenReaderOnly
